module.exports = __webpack_public_path__ + "static/waves-events-99f6ed5930347650155c6bf485817266.svg";